import React, { useEffect, useState } from 'react';
import { Match } from '../../types/types';
import PlayerDataGrid from '../DataGrid/PlayerDataGrid';
import { RenderTeamCell, RenderTeamCellToolTip } from '../../globals/TableFunctions';
import { GridColDef, GridCellParams, GridRowParams, GridEvents, MuiEvent, GridCallbackDetails, GridRenderCellParams } from '@mui/x-data-grid';
import { TeamLogos, TeamsList } from '../../globals/Globals';

export interface Props {
    matches: Match[];
    teamname: string;
}

const fixtureColumns:GridColDef[]  = [
    { field: 'season', headerName: 'Season', width: 75 },
    { field: 'round', headerName: 'Rd' , type: "number", width: 50 },
    { field: 'date', headerName: 'Date', width: 100 },
    { field: 'opposition', headerName: 'Opponent', width: 190,
        renderCell: (params: GridRenderCellParams<Date>) => (RenderTeamCell(params.row.opposition, params.row.oppositionlogo, params.row.oppositioncolors))
    },
    { field: 'location', headerName: "Location", width:180},
]

function BuildUpcomingGamesRows(matches,teamname) {
    let rows = [];
    rows = matches.map(function(match) {
        let oppositionname = '';
        match.teams.map(function(team) {
            if (team.name !== teamname) {
                oppositionname = team.name;
            }
        })
        // let oppositionname = game.opposition?.name ? game?.opposition?.name : '';
        let oppositioncolors:string[] = TeamsList[oppositionname];
        // let predictedPriceChange:number = game.nextRoundPredictedPrice - game.price;
        
        return ({
            id: `${match.id}-index`,
            season: match.season,
            date: match.date,
            oppositionname: oppositionname,
            oppositionlogo: TeamLogos[oppositionname],
            opposition: oppositionname,
            oppositioncolors: oppositioncolors,
            ...match
        })

    });
    console.log("BuildUpcomingGameRows: ", rows);
    return rows
}

const UpcomingGamesTable = ({matches, teamname}:Props) => {
    const [ rows, setRows ] = useState([]);
    useEffect(() => {
        setRows(BuildUpcomingGamesRows(matches,teamname))
    },[matches])
    return (<PlayerDataGrid
        height={600}
        columns={fixtureColumns}
        rows={rows}
    />)
}

export default UpcomingGamesTable;